<script setup lang="ts">
import type { TagVariants } from '.';

import { cn } from '@/utils';
import { Primitive } from 'reka-ui';

import { tagVariants } from '.';

defineProps<{
	variant?: TagVariants['variant'];
	textClass?: string;
}>();
</script>

<template>
	<Primitive
		as="div"
		:class="cn(tagVariants({ variant }), $attrs.class as string)"
	>
		<slot name="icon" />
		<p
			:class="
				cn(
					'text-center font-Inter text-xs font-medium leading-[150%]',
					variant === 'translucent' ? 'text-white' : 'text-primary',
					textClass
				)
			"
		>
			<slot />
		</p>
	</Primitive>
</template>
